export default "__VITE_ASSET__CYWFT_dD__"